import React, { useState } from 'react';
import { useRouter } from 'next/router';
import Swal from 'sweetalert2';
import { Lock, User } from 'lucide-react';

const AdminLogin = () => {
    const [credentials, setCredentials] = useState({ username: '', password: '' });
    const [loading, setLoading] = useState(false);
    const router = useRouter();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const apiUrl = `${window.location.origin}/projectbim/api/login`;
            const res = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(credentials)
            });

            let data;
            const contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                data = await res.json();
            } else {
                const text = await res.text();
                console.error("Non-JSON Response:", text);
                throw new Error('Server returned HTML instead of JSON. Check terminal for Next.js API route errors.');
            }

            if (res.ok) {
                localStorage.setItem('adminToken', data.token);
                Swal.fire({
                    title: 'Welcome Admin!',
                    text: 'Login successful.',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                });
                router.push('/admin/create-blog');
            } else {
                Swal.fire('Login Failed', data.error || 'Invalid credentials', 'error');
            }
        } catch (error) {
            console.error("Login Error details:", error);
            Swal.fire('Error', 'Server connection failed. Open browser console (F12) for details.', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ backgroundColor: '#050505', minHeight: 'calc(100vh - 80px)', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '120px 20px 80px', boxSizing: 'border-box' }}>
                <div style={{ 
                    width: '100%', 
                    maxWidth: '450px', 
                    backgroundColor: '#111', 
                    padding: '50px 40px', 
                    borderRadius: '24px', 
                    border: '1px solid #333',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.8)',
                    boxSizing: 'border-box'
                }}>
                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <div style={{ display: 'inline-flex', padding: '15px', backgroundColor: 'rgba(84, 178, 72, 0.1)', borderRadius: '50%', marginBottom: '20px' }}>
                            <Lock size={40} color="#54b248" />
                        </div>
                        <h1 style={{ color: '#fff', fontSize: '32px', margin: '0 0 10px 0' }}>Admin Login</h1>
                        <p style={{ color: '#888', margin: 0 }}>Secure access to your dashboard</p>
                    </div>

                    <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <div style={{ position: 'relative', width: '100%', boxSizing: 'border-box' }}>
                            <User size={20} color="#888" style={{ position: 'absolute', left: '15px', top: '16px' }} />
                            <input
                                type="text"
                                placeholder="Username"
                                value={credentials.username}
                                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                                required
                                style={{ width: '100%', boxSizing: 'border-box', padding: '15px 15px 15px 50px', backgroundColor: '#000', border: '1px solid #333', borderRadius: '12px', color: '#fff', fontSize: '16px', outline: 'none', transition: 'border-color 0.3s' }}
                                onFocus={(e) => e.target.style.borderColor = '#54b248'}
                                onBlur={(e) => e.target.style.borderColor = '#333'}
                            />
                        </div>

                        <div style={{ position: 'relative', width: '100%', boxSizing: 'border-box' }}>
                            <Lock size={20} color="#888" style={{ position: 'absolute', left: '15px', top: '16px' }} />
                            <input
                                type="password"
                                placeholder="Password"
                                value={credentials.password}
                                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                                required
                                style={{ width: '100%', boxSizing: 'border-box', padding: '15px 15px 15px 50px', backgroundColor: '#000', border: '1px solid #333', borderRadius: '12px', color: '#fff', fontSize: '16px', outline: 'none', transition: 'border-color 0.3s' }}
                                onFocus={(e) => e.target.style.borderColor = '#54b248'}
                                onBlur={(e) => e.target.style.borderColor = '#333'}
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                width: '100%',
                                boxSizing: 'border-box',
                                marginTop: '10px',
                                padding: '16px',
                                backgroundColor: loading ? '#3a7a31' : '#54b248',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '12px',
                                fontSize: '18px',
                                fontWeight: 'bold',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: loading ? 'none' : '0 10px 20px rgba(84, 178, 72, 0.2)'
                            }}
                        >
                            {loading ? 'Authenticating...' : 'Login Now'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
